const INTENT_KEY_MAP = {
  appraisal: "welcome.intentAppraisal",
  complaint: "welcome.intentComplaint",
  information: "welcome.intentInformation",
  request: "welcome.intentRequest",
  remark: "welcome.intentRemark",
  mixed: "welcome.sentimentMixed",
};

const SENTIMENT_KEY_MAP = {
  positive: "welcome.sentimentPositive",
  negative: "welcome.sentimentNegative",
  neutral: "welcome.sentimentNeutral",
  mixed: "welcome.sentimentMixed",
};

const DECISION_KEY_MAP = {
  Publish: "welcome.decisionPublish",
  "Do not Publish": "welcome.decisionDoNotPublish",
  "Open a case": "welcome.decisionOpenCase",
  "Do not open a case": "welcome.decisionDoNotOpenCase",
  "Take action": "welcome.decisionTakeAction",
  "Do not take action": "welcome.decisionDoNotTakeAction",
};

function norm(label) {
  return String(label || "").trim().toLowerCase();
}

export function translateIntentLabel(label, t) {
  if (!label || typeof t !== "function") return label || "";
  const key = INTENT_KEY_MAP[norm(label)];
  return key ? t(key, label) : label;
}

export function translateSentimentLabel(label, t) {
  if (!label || typeof t !== "function") return label || "";
  const key = SENTIMENT_KEY_MAP[norm(label)];
  return key ? t(key, label) : label;
}

export function translateDecisionLabel(label, t) {
  if (!label || typeof t !== "function") return label || "";
  const key = DECISION_KEY_MAP[String(label).trim()];
  return key ? t(key, label) : label;
}
